import React from 'react';

const Contact: React.FC = () => {
  return (
    <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-white p-4 lg:p-6 xl:p-8 portrait:p-3">
      <div className="bg-white rounded-lg lg:rounded-xl xl:rounded-2xl 2xl:rounded-3xl portrait:rounded-lg shadow-lg lg:shadow-xl portrait:shadow-md p-6 lg:p-8 xl:p-10 2xl:p-12 portrait:p-4 max-w-sm lg:max-w-md xl:max-w-lg 2xl:max-w-xl portrait:max-w-xs w-full">
        <h2 className="text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl portrait:text-lg font-bold text-gray-900 mb-3 lg:mb-4 xl:mb-6 portrait:mb-2 text-center">联系我们</h2>
        <p className="text-sm lg:text-base xl:text-lg portrait:text-xs text-gray-600 mb-6 lg:mb-8 portrait:mb-4 text-center">如有合作、咨询或技术支持需求，欢迎通过以下方式联系我们。</p>
        
        <div className="mb-4 lg:mb-6 portrait:mb-3">
          <div className="flex items-center mb-2 lg:mb-3 portrait:mb-1.5">
            <span className="font-medium w-16 lg:w-20 xl:w-24 portrait:w-14 text-sm lg:text-base portrait:text-xs">电话：</span>
            <span className="text-sm lg:text-base portrait:text-xs">400-123-4567</span>
          </div>
          <div className="flex items-center mb-2 lg:mb-3 portrait:mb-1.5">
            <span className="font-medium w-16 lg:w-20 xl:w-24 portrait:w-14 text-sm lg:text-base portrait:text-xs">邮箱：</span>
            <span className="text-sm lg:text-base portrait:text-xs">contact@chaincloud.com</span>
          </div>
        </div>
        
        <form className="space-y-3 lg:space-y-4 portrait:space-y-2">
          <input 
            type="text" 
            placeholder="您的姓名" 
            className="w-full px-3 lg:px-4 portrait:px-2 py-2 lg:py-3 portrait:py-1.5 border border-gray-300 rounded-lg portrait:rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm lg:text-base portrait:text-xs" 
          />
          <input 
            type="email" 
            placeholder="您的邮箱" 
            className="w-full px-3 lg:px-4 portrait:px-2 py-2 lg:py-3 portrait:py-1.5 border border-gray-300 rounded-lg portrait:rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm lg:text-base portrait:text-xs" 
          />
          <textarea 
            placeholder="您的留言" 
            rows={window.matchMedia('(orientation: portrait)').matches ? 3 : 4} 
            className="w-full px-3 lg:px-4 portrait:px-2 py-2 lg:py-3 portrait:py-1.5 border border-gray-300 rounded-lg portrait:rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm lg:text-base portrait:text-xs" 
          />
          <button 
            type="submit" 
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-2 lg:py-3 portrait:py-1.5 rounded-lg portrait:rounded-md font-medium text-sm lg:text-base portrait:text-xs hover:from-blue-700 hover:to-purple-700 transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            发送
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact; 